import React, { useEffect } from 'react';
import { connect,useDispatch } from 'react-redux';
import { compose } from 'redux';
import { useParams } from 'react-router-dom';
import {getDataOnRequest} from '../redux/actions/CommonActions'
const Job = (OriginalComponent) => {
  const NewComponent = (props) => {
    const params = useParams();
    const { userAuth} = props;
    const dispatch = useDispatch();
    useEffect(()=>{
      if(userAuth.users_access_token && params.id)
        dispatch(getDataOnRequest(userAuth.users_access_token,'GetJob','SET_JOB',params.id))
    }, [userAuth.users_access_token, params.id, dispatch]);
    return (
      <OriginalComponent {...props}  />
    )
  }
  return NewComponent
}

const mapStateToProps = (state) => {
  return {
    userAuth:state.auth.authUserData,
    bankInfo:state.bankInfo.bankInfo,
    job:state.job.job
  };
};

const composedJob = compose(connect(mapStateToProps), Job)
export default composedJob;

